import { useEffect, useState } from "react"
import styles from 'styles/NewsIndex.module.css';
import { NewsData, NewsLabelData } from 'interfaces/news';
import { getNews, getNewsLabels } from 'lib/api/news';
import DefaultThumbnail from 'assets/images/news/AREA_CUP_logo_original.png';
import Pager from 'components/features/Pager'
import FilterButtons from 'components/features/FilterButtons'
import TitleLine from 'assets/images/news/title_line.png';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

const NewsIndex = () => {
  const [newsData, setNewsData] = useState<NewsData[]>([]);
  const [labels, setLabels] = useState<NewsLabelData[]>([{ "newsLabel": "ALL" }]);
  const [selectedLabel, setSelectedLabel] = useState<string>('ALL');

  const filteredNewsData =
    selectedLabel === 'ALL'
      ? newsData
      : newsData.filter((news) => news.newsLabel === selectedLabel);

  const handleGetNews = async () => {
    const res = await getNews()

    if (res.status == 200) {
      setNewsData(res.data)
    }
  }

  const handleGetNewsLabels = async () => {
    const res = await getNewsLabels()

    if (res.status == 200) {
      setLabels([{ "newsLabel": "ALL" }, ...res.data]);
    }
  }

  useEffect(() => {
    handleGetNews()
    handleGetNewsLabels()
  }, [])

  const [currentPage, setCurrentPage] = useState<number>(1);
  const articlesPerPage = 9;

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = filteredNewsData.slice(indexOfFirstArticle, indexOfLastArticle);

  const totalPages = Math.ceil(filteredNewsData.length / articlesPerPage);

  const formatDate = (dateInput: Date): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}.${month}.${day}`;
  }

  const navigate = useNavigate();

  const handleButtonClick = (path: string) => {
    navigate(path);
  };

  return (
    <>
      <div className={styles["first-view"]}>
        <Helmet>
          <title>最新情報 | AREA CUP</title>
          <meta property="og:title" content="最新情報 | AREA CUP" />
          <meta name="twitter:title" content="最新情報 | AREA CUP" />
        </Helmet>
        <h1 className={styles["rulebook-title"]}>THE LATEST</h1>
        <div className={styles["rulebook-guideline"]}>
          <h2 className={styles["rulebook-guideline-text"]}>最新情報</h2>
          <img src={TitleLine} className={styles["rulebook-guideline-image"]} draggable="false" />
          <div className={styles["diamond1"]}></div>
          <div className={styles["diamond2"]}></div>
        </div>
      </div>
      <div className={styles["news-container"]}>      
        <div className={styles["container"]}>
          <FilterButtons
            labels={labels}
            selectedLabel={selectedLabel}
            setSelectedLabel={setSelectedLabel}
            setCurrentPage={setCurrentPage}
          />
          <div className={styles["card-container-main"]}>
            {currentArticles.map((item) => (
              <div className={styles["card"]} onClick={() => handleButtonClick(`/news/${item.urlHash}`)}>
                <img src={item.thumbnail || DefaultThumbnail} alt={item.title} />
                <div className={styles["card-content"]}>
                  <div className={styles["card-content-info"]}>
                    <span className={styles["label"]} style={{ backgroundColor: item.newsLabelColorCode }}>{item.newsLabel}</span>
                    <span className={styles["date"]}>{formatDate(item.releasedAt)}</span>
                  </div>
                  <h3>{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
          <Pager currentPage={currentPage} totalPages={totalPages} handlePageClick={setCurrentPage} />
        </div>
      </div>
    </>
  );
};

export default NewsIndex;
